import { jsx } from "react/jsx-runtime";
import { parseTaxId } from "@batiflow/i18n";
import { Input } from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormField, fieldErrorText } from "../form-field/form-field.js";
const PLACEHOLDER = "1234567 A / A / M / 000";
function TaxIdInput({
  value,
  onChange,
  allowShort = false,
  label,
  hint,
  error,
  required,
  disabled,
  name,
  "aria-label": ariaLabel,
  onBlur
}) {
  const { t } = useTranslation("ui");
  const [draft, setDraft] = useState(null);
  const [problem, setProblem] = useState(null);
  const committed = value ? parseTaxId(value, { allowShort }) : null;
  const committedText = committed?.valid ? committed.display : value ?? "";
  const text = draft ?? committedText;
  const commit = () => {
    if (draft === null) return;
    const result = parseTaxId(draft, { allowShort });
    if (!result.valid) {
      if (result.error === "EMPTY") {
        setDraft(null);
        setProblem(required ? t("common:taxId.EMPTY") : null);
        onChange(null);
      } else {
        setProblem(t(`common:taxId.${result.error}`));
      }
      return;
    }
    setProblem(null);
    setDraft(null);
    onChange(result.normalized);
  };
  const handleChange = (event) => {
    setDraft(event.target.value);
    setProblem(null);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") commit();
  };
  return /* @__PURE__ */ jsx(
    FormField,
    {
      ...label ? { label } : {},
      ...hint ? { hint } : {},
      ...required ? { required } : {},
      error: problem ?? fieldErrorText(error),
      children: /* @__PURE__ */ jsx(
        Input,
        {
          ...name ? { name } : {},
          ...ariaLabel ? { "aria-label": ariaLabel } : {},
          ...disabled ? { disabled } : {},
          value: text,
          dir: "ltr",
          root: { dir: "ltr" },
          placeholder: PLACEHOLDER,
          maxLength: 40,
          autoComplete: "off",
          spellCheck: false,
          autoCapitalize: "characters",
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          onBlur: () => {
            commit();
            onBlur?.();
          }
        }
      )
    }
  );
}
export {
  TaxIdInput
};
//# sourceMappingURL=tax-id-input.js.map